import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/entrypoint.tsx';
import { softwareTimelineEntrypoint as softwareHarmonisedTimelineEntrypoint } from '@jira/spa-apps__harmonised-software-timeline/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { nav4SidebarContentCoreEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-core/entrypoint.tsx';
import { nav4ProjectsContentEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-core/src/ui/projects/default/async-content/entrypoint.tsx';
import { softwareTimelineEntrypoint } from '@atlassian/jira-spa-apps-roadmap/src/view/entrypoint.tsx';

const pageEntryPointConfig = {
	main: softwareTimelineEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: {
			projects: {
				entryPoint: nav4ProjectsContentEntryPoint,
			},
		},
		isProjectsExpanded: true,
	},
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
};

export const softwareTimelinePageEntrypoint = createPageEntryPoint(pageEntryPointConfig);

export const softwareHarmonisedTimelinePageEntrypoint = createPageEntryPoint({
	...pageEntryPointConfig,
	main: softwareHarmonisedTimelineEntrypoint,
});
